//import the vue instance
import Vue from "vue";
//import the App component
import App from "./App";
//import the vue router
import VueRouter from "vue-router";

import Vuetify from "vuetify";


Vue.use(Vuetify);

import "vuetify/dist/vuetify.min.css";

import vueCountryRegionSelect from "vue-country-region-select";
Vue.use(vueCountryRegionSelect);

import { store } from "./store/";

import axios from "axios";

//tell vue to use the router
Vue.use(VueRouter);
/* eslint-disable no-new */

import VueResourse from "vue-resource";
Vue.use(VueResourse);

import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

// import InstantSearch from 'vue-instantsearch'
// Vue.use(InstantSearch);

import contact_form from "./components/contact_form";
import tax_exemption_form from "./components/tax_exemption_form";
import catalog_request_form from "./components/catalog_request_form";
import customer_interaction_form from './components/customer_interaction_form'

//define your routes
const routes = [
  {
    name: "contact_form",
    path: "/",
    component: contact_form
  },
  {
    name: "tax_exemption_form",
    path: "/tax_exemption_form",
    component: tax_exemption_form
  },
  {
    name: "catalog_request_form",
    path: "/catalog_request_form",
    component: catalog_request_form
  },
  {
  	name: 'customer_interaction_form',
  	path: '/customer_interaction_form',
  	component: customer_interaction_form
  }
];

const router = new VueRouter({
  routes, // short for routes: routes
  mode: "history"
});

//instatinat the vue instance
new Vue({
  //define the selector for the root component
  el: "#app",
  //pass the template to the root component
  template: "<App/>",
  //declare components that the root component can access
  components: { App },
  //pass in the router to the vue instance
  render: h => h(App),
  router,
  store
}).$mount("#app"); //mount the router on the app



// WEBPACK FOOTER //
// ./src/main.js